import ContentfulApi from "../../lib/ContentfulApi";
import {
  FETCH_NECKLACES,
  FETCH_MEMORIES,
  SELECT_ACTIVE_NECKLACE,
  SET_CALCULATE_NECKLACE_PRICE,
  CLOSE_NECKLACE_MODALS,
  TOGGLE_MEMORY_COLLECTIONS,
  REMOVE_ACTIVE_MEMORY_BY_INDEX,
  ADD_ACTIVE_MEMORY_BY_INDEX,
  RESET_ACTIVE_EDIT_MEMORY,
} from "./types";
import Helpers from "../../lib/Helpers";

export const initNecklacesAndMemories = (query) => {
  return (dispatch) => {
    // Fetch necklaces:
    dispatch(fetchNecklaces(query));

    // Fetch memories:
    dispatch(fetchMemories(query));
  };
};

export const fetchNecklaces = (query) => {
  return (dispatch) => {
    console.log("initializing necklaces...");
    const api = new ContentfulApi();
    api
      .getNecklaces()
      .then((response) => {
        if (response.items && response.includes) {
          const helpers = new Helpers();
          const formattedResponse = helpers.formatResponse(
            response,
            "necklace"
          );
          dispatch({
            type: FETCH_NECKLACES,
            payload: formattedResponse,
          });
          dispatch(selectActiveNecklace(query));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const fetchMemories = (query) => {
  return (dispatch) => {
    const api = new ContentfulApi();
    console.log("initializing memories...");
    api
      .getMemories()
      .then((response) => {
        if (response.items && response.includes) {
          const helpers = new Helpers();
          const formattedResponse = helpers.formatResponse(response, "memory");
          dispatch({
            type: FETCH_MEMORIES,
            payload: formattedResponse,
          });
          dispatch(selectActiveMemoriesFromQueryParams(query));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

const selectActiveMemoriesFromQueryParams = (query) => {
  return (dispatch, getState) => {
    const memories = getState().necklace.memories;
    if (memories && query) {
      for (let i = 1; i <= 14; i++) {
        const key = `m${i}`;
        if (key in query) {
          for (let y = 0; y < memories.items.length; y++) {
            if (memories.items[y].sys.id === query[key]) {
              dispatch({
                type: ADD_ACTIVE_MEMORY_BY_INDEX,
                memory: memories.items[y],
                index: i,
                engraving: atob(query[`me${i}`]),
                material: query[`mm${i}`],
              });
              break;
            }
          }
        } else {
          break;
        }
      }
    }
  };
};

export const selectActiveNecklace = (queryParams) => {
  return (dispatch, getState) => {
    if (!getState().necklace.necklaces) {
      console.log("Could not find necklaces.");
      return;
    }
    const necklaces = getState().necklace.necklaces;
    let defaultNecklace = false;
    if (queryParams) {
      if (queryParams.necklace && queryParams.necklace === "default") {
        defaultNecklace = true;
      }
    } else {
      defaultNecklace = true;
    }
    // Show default necklace:
    if (defaultNecklace) {
      dispatch({
        type: SELECT_ACTIVE_NECKLACE,
        payload: getNecklaceByCollection(queryParams.collection, necklaces),
      });
    }
    // Show necklace based on the id on url:
    else {
      let necklaceNotFound = true;
      for (let i = 0; i < necklaces.items.length; i++) {
        if (necklaces.items[i].sys.id === queryParams.necklace) {
          dispatch({
            type: SELECT_ACTIVE_NECKLACE,
            payload: necklaces.items[i],
          });
          necklaceNotFound = false;
        }
      }
      if (necklaceNotFound) {
        dispatch({
          type: SELECT_ACTIVE_NECKLACE,
          payload: getNecklaceByCollection(queryParams.collection, necklaces),
        });
      }
    }
  };
};

export const setCalculateNecklacePrice = (value = true) => {
  return (dispatch) => {
    dispatch({
      type: SET_CALCULATE_NECKLACE_PRICE,
      payload: value,
    });
  };
};

export const selectActiveNecklaceFromModal = (item) => {
  return (dispatch) => {
    if (item) {
      dispatch({
        type: SELECT_ACTIVE_NECKLACE,
        payload: item,
      });
      dispatch({
        type: CLOSE_NECKLACE_MODALS,
      });
    }
  };
};

const getNecklaceByCollection = (collection, necklaces) => {
  if (collection && necklaces && necklaces.items.length) {
    for (let i = 0; i < necklaces.items.length; i++) {
      if (necklaces.items[i].fields.collectionTitle === collection) {
        return necklaces.items[i];
      }
    }
  }
};

export const toggleMemoryCollections = (id) => {
  return (dispatch) => {
    if (id) {
      dispatch({
        type: TOGGLE_MEMORY_COLLECTIONS,
        payload: id,
      });
    }
  };
};

export const selectActiveMemory = (
  memory = null,
  index = 0,
  engraving = "",
  material = ""
) => {
  return (dispatch) => {
    if (memory === null) {
      // Remove memory:
      dispatch({
        type: REMOVE_ACTIVE_MEMORY_BY_INDEX,
        index,
      });
      dispatch({
        type: RESET_ACTIVE_EDIT_MEMORY,
      });
    } else {
      dispatch({
        type: ADD_ACTIVE_MEMORY_BY_INDEX,
        memory,
        index,
        engraving,
        material,
      });
      dispatch({
        type: RESET_ACTIVE_EDIT_MEMORY,
      });
    }
  };
};
